import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import SliderInput from "./QuestionInputSlider";
import RadioInput from "./QuestionInputRadio";
import { IQuestion, InputType } from "../../surveyTypes";
import { SurveyFormContext } from "../Survey";
import { SurveySectionContext } from "../SurveySection";

const Question: React.FC<IQuestion> = (props: IQuestion) => {
  const { questionText, id } = props;
  const { answers } = React.useContext(SurveyFormContext);
  const { minValue, maxValue, step, inputType } = React.useContext(
    SurveySectionContext
  );
  let checkedValue = null;
  if (id in answers) {
    checkedValue = answers[id].value;
  }
  let colspan = 1;
  if (inputType === InputType.RADIO) {
    colspan = (maxValue - minValue) / step + 1;
  }
  return (
    <React.Fragment>
      <TableRow>
        <TableCell colSpan={colspan}>{questionText}</TableCell>
      </TableRow>
      <TableRow>
        {inputType === InputType.RADIO && (
          <RadioInput
            checkedValue={checkedValue}
            questionId={id}
            min_value={minValue}
            max_value={maxValue}
            step={step}
          />
        )}
        {inputType === InputType.SLIDER && (
          <SliderInput
            checkedValue={checkedValue}
            questionId={id}
            min_value={minValue}
            max_value={maxValue}
            step={step}
          />
        )}
      </TableRow>
    </React.Fragment>
  );
};

export default Question;
